import { Component } from '@angular/core'
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent, FeatureType } from '../../shared'
import { NotificationActiveUsersComponent } from './active-users/active-users.component'
import { NotificationTemplatesComponent } from './notification-templates.component'
import { SentNotificationsComponent } from './sent-notifications.component'

@Component({
    templateUrl: './notifications.component.html',
    standalone: true,
    imports: [
        NgbNav,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        NotificationTemplatesComponent,
        SentNotificationsComponent,
        NotificationActiveUsersComponent,
    ],
})
export class NotificationsComponent extends BaseComponent {
    active = 1

    get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.HrNotificationEdit])
    }
}
